<section class="how-to-buy-wrapper">
    <div class="container">
        <div>
          <img src="/assets/images/top-img.svg" alt="image" class="top-img">
          <img src="/assets/images/rightimg.svg" alt="image" class="top-right-img">
        </div>
        <div class="more-info py-5">   
          
              <div class="row">
                <div class="col-md-8 offset-md-2">
                  <h3 class="pt-5 title my-5 text-white text-center text-uppercase fw-bold ">{{"how_to_buy_page_title" | translate}}<br/>{{"how_to_buy_page_title1" | translate}}</h3>
               </div>
               <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3 mb-5 pb-4">
               
                 <div class="form-wrapper p-4 bg-secondary">
                    <p class="text-white font-18 fe-medium text-center mb-4">{{"how_to_buy_page_desc" | translate}}</p>
          
                    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          
                      <div class="form-group mb-4">
                        <label class="text-white font-16 mb-2">First Name</label>
                        <input type="text" [ngClass]="{ 'is-invalid':(f['firstname'].touched || isSubmitted) && f['firstname'].errors  }" formControlName="firstname" class="form-control" value="" placeholder="John">
                        <div *ngIf="(f['firstname'].touched || isSubmitted)  && f['firstname'].errors " class="invalid-feedback">
                          <div *ngIf="f['firstname'].errors['required']" class="error"><span translate>firstname_req</span>
                          </div>
                        </div>
                      </div>
          
                      <div class="form-group mb-4">
                        <label class="text-white font-16 mb-2">Last Name</label>
                        <input [ngClass]="{ 'is-invalid':(f['lastname'].touched || isSubmitted) && f['lastname'].errors  }" class="form-control" type="text" formControlName="lastname" value="" placeholder="Doe">
                        <div *ngIf="(f['lastname'].touched || isSubmitted)  && f['lastname'].errors " class="invalid-feedback">
                          <div *ngIf="f['lastname'].errors['required']" class="error"><span translate>lastname_req</span>
                          </div>
                        </div>
                      </div>
          
                      <div class="form-group mb-4">
                        <label class="text-white font-16 mb-2">Email</label>
                        <input type="email" formControlName="email" placeholder="johnsmith@mail.com" class="form-control" [ngClass]="{'is-invalid':(f['email'].touched || isSubmitted) && f['email'].errors}">
                        <div *ngIf="(f['email'].touched || isSubmitted)  && f['email'].errors " class="invalid-feedback">
                          <div *ngIf="f['email'].errors['required']" class="error">
                            <span translate>email_req</span>
                          </div>
                        </div>
                        <div *ngIf="(f['email'].touched || isSubmitted) && f['email'].errors" class="invalid-feedback">
                          <div *ngIf="f['email'].errors['email'] || f['email'].errors['pattern']" class="error"><span translate>email_invalid</span>
                          </div>
                        </div>
                      </div>
          
                      <div class="form-group mb-4">
                        <label class="text-white font-16 mb-2">Phone Number</label>
                        <input [ngClass]="{ 'is-invalid':(f['phone'].touched || isSubmitted) && f['phone'].errors  }"  class="form-control" formControlName="phone" type="tel" placeholder="+44 7123 456789">
                        <div *ngIf="(f['phone'].touched || isSubmitted)  && f['phone'].errors " class="invalid-feedback">
                          <div *ngIf="f['phone'].errors['required']" class="error"><span translate>phone_req</span></div>
                        </div>
                      </div>
          
                      <div class="form-group mb-4">
                        <label class="text-white font-16 mb-2">Best Time to Contact</label>
                        <select class="form-control" aria-placeholder="Morning" formControlName="besttime">
                          <option>Morning</option>
                          <option>Evening</option>
                        </select>
                        <div *ngIf="(f['besttime'].touched || isSubmitted)  && f['besttime'].errors " class="invalid-feedback">
                          <div *ngIf="f['besttime'].errors['required']" class="error"><span translate>best_time_req</span>
                          </div>
                        </div>
                      </div>
          
                      <div class="form-group mb-4">
                        <label class="text-white font-16 mb-2">Budget</label>
                        <select class="form-control" aria-placeholder="$1-10k" formControlName="budget">
                          <option>$1-10k</option>
                          <option>$10-30k</option>
                          <option>$30-40k</option>
                        </select>
                      </div>
          
                      <div class="form-group mb-2 pt-1">
                        <button type="submit" [disabled]="contactForm.invalid" class="btn btn-white text-uppercase w-100 py-3 fw-semibold font-18">{{(isSubmitted ? 'formSuccess' : 'submit') | translate}}</button>
                      </div>
                    </form>
                 </div>
               </div>
            </div>
           
           </div>
    </div>
</section>